import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const features = [
  {
    icon: FiIcons.FiSend,
    title: "Native Multi-Posting",
    description: "Reach Instagram, TikTok, LinkedIn, Facebook, YouTube, Threads, and 7 more networks simultaneously with native-formatted content."
  },
  {
    icon: FiIcons.FiClock,
    title: "Intelligence Scheduling",
    description: "Execute your social strategy in advance. Schedule posts for peak engagement times across different time zones automatically."
  },
  {
    icon: FiIcons.FiLayers,
    title: "Auto-Transformation",
    description: "Bifrost detects platform requirements and automatically adjusts media sizes, caption lengths, and hashtag rules for perfect quality."
  },
  {
    icon: FiIcons.FiImage,
    title: "Total Media Freedom",
    description: "Full support for every format: High-res images, 4K video, Reels, TikToks, Carousels, and punchy text-only updates."
  },
  {
    icon: FiIcons.FiShield,
    title: "Quality Assurance",
    description: "Stop worrying about blurry uploads. We maintain the highest bitrates and resolution standards across every single platform."
  },
  {
    icon: FiIcons.FiCheckCircle,
    title: "Unified Interface",
    description: "Just write your post, pick where it goes, and watch it go live. No more jumping between 13 different apps and logins."
  }
];

const BifrostFeatures = () => {
  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-base font-semibold text-indigo-600 tracking-wide uppercase">Why Bifrost?</h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
            The power of a full social media team in one tool
          </p>
          <p className="mt-4 max-w-2xl text-xl text-gray-500 mx-auto">
            Scale your event's reach without scaling your workload. Bifrost handles the heavy lifting of cross-platform distribution.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              viewport={{ once: true }}
              className="relative p-8 bg-white rounded-2xl hover:shadow-xl transition-all duration-300 border border-gray-100 group"
            >
              <div className="mb-6 inline-flex items-center justify-center p-3 bg-indigo-600 rounded-xl shadow-lg group-hover:rotate-6 transition-transform">
                <SafeIcon icon={feature.icon} className="h-6 w-6 text-white" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed text-sm">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BifrostFeatures;